import { render } from "./CheckBoxComponent.vue?vue&type=template&id=5c297ea4"
import script from "./CheckBoxComponent.vue?vue&type=script&lang=js"
export * from "./CheckBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__